import { FlickityPatched } from "@sazka/utils/carousel/flickity-patched";
let flickity: FlickityPatched = null;

const useDataSelectorBase = (name: string) => `[data-ds-slider="${name}"]`;

$(() => {
    const root = document.querySelector(useDataSelectorBase("root"));
    if (!root) return;

    const carousel = root.querySelector(useDataSelectorBase("carousel"));
    if (!carousel) return;

    const btnPrev = root.querySelector(useDataSelectorBase("slider-prev"));
    const btnNext = root.querySelector(useDataSelectorBase("slider-next"));

    flickity = new FlickityPatched(carousel, {
        prevNextButtons: false,
        adaptiveHeight: true,
        setGallerySize: false,
        pageDots: false,
    });

    if (flickity.selectedIndex === 0) {
        btnPrev.classList.add("is-disabled");
    }

    flickity.on("select", function () {
        if (!flickity.slides[flickity.selectedIndex - 1]) {
            btnPrev.classList.add("is-disabled");
            btnNext.classList.remove("is-disabled");
        } else if (!flickity.slides[flickity.selectedIndex + 1]) {
            btnNext.classList.add("is-disabled");
            btnPrev.classList.remove("is-disabled");
        } else {
            btnPrev.classList.remove("is-disabled");
            btnNext.classList.remove("is-disabled");
        }
    });

    flickity.on("change", function (index: number) {
        document.querySelector(`[data-slide-stepper-index="${index - 1}"]`)?.classList.add("d-none");
        document.querySelector(`[data-slide-stepper-index="${index}"]`)?.classList.remove("d-none");
        document.querySelector(`[data-slide-stepper-index="${index + 1}"]`)?.classList.add("d-none");
    });

    btnPrev.addEventListener("click", function () {
        if (flickity.selectedIndex - 1 === 0) {
            btnPrev.classList.add("is-disabled");
        }

        if (flickity.selectedIndex - 1 !== 0) btnNext.classList.remove("is-disabled");

        flickity.previous();
    });

    btnNext.addEventListener("click", () => {
        if (flickity.selectedIndex + 1 > 0) {
            btnPrev.classList.remove("is-disabled");
        }

        if (flickity.selectedIndex + 1 === flickity.slides.length - 1) btnNext.classList.add("is-disabled");

        flickity.next();
    });

    window.addEventListener("load", () => {
        flickity.reposition();
    });
});
